module.exports = __webpack_public_path__ + "static/media/Ticking3.1441cee6.mp3";